<ng-container *transloco="let t">
  <div
    id="toast-container"
    class="fixed top-4 left-4 right-4 md:left-auto md:right-4 z-100 flex flex-col gap-3 md:max-w-[400px]"
  >
    @for (toast of toastService.toasts(); track toast.id) {
      <div
        [id]="'toast-' + toast.id"
        class="flex items-start gap-3 p-4 rounded-lg shadow-lg font-dm animate-slide-in-right"
        [class]="getToastClasses(toast.type)"
        role="alert"
      >
        <div class="shrink-0 mt-0.5">
          <mat-icon class="w-5! h-5! text-[20px]!">{{ getIcon(toast.type) }}</mat-icon>
        </div>

        <div class="flex-1 min-w-0">
          @if (toast.header) {
            <p class="text-sm font-semibold">{{ toast.header }}</p>
          }
          <p class="text-sm" [class.mt-1]="toast.header">{{ toast.message }}</p>
          @if (toast.actionLabel && toast.actionCallback) {
            <button
              type="button"
              class="mt-2 text-sm font-bold underline cursor-pointer bg-transparent border-none p-0"
              (click)="onAction(toast)"
            >
              {{ toast.actionLabel }}
            </button>
          }
        </div>

        @if (toast.dismissible) {
          <button
            type="button"
            class="shrink-0 p-1 rounded-full hover:bg-black/10 transition-colors"
            (click)="onDismiss(toast)"
            [attr.aria-label]="t('toastDismiss')"
          >
            <mat-icon class="w-4! h-4! text-[16px]!">close</mat-icon>
          </button>
        }
      </div>
    }
  </div>
</ng-container>
